import { Component, OnInit } from "@angular/core";
import { UserProfile } from "src/app/parametrage/core/model/user-profile";
import { DatePipe } from "@angular/common";
import { UserProfileService } from "src/app/parametrage/core/service/user-profile.service";
import { ReportingProfilService } from "../core/service/reporting-profil.service";

@Component({
  selector: "app-extraction-par-profil",
  templateUrl: "./extraction-par-profil.component.html",
  styleUrls: ["./extraction-par-profil.component.scss"],
})
export class ExtractionParProfilComponent implements OnInit {
  debut: any = null;
  fin: any = null;
  profile: String;

  userProfiles: UserProfile[];

  constructor(
    private datePipe: DatePipe,
    private _userProfileService: UserProfileService,
    private _reportingService: ReportingProfilService
  ) {}

  ngOnInit() {
    this.getUserProfiles();
  }

  getUserProfiles() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userProfiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  exportQuantiteDossiersByEmployee() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportQuantiteDossiersByEmployee(deb, fn, this.profile)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "quantite-dossier-by-employee-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersRecuByEmployee() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersRecuByEmployee(deb, fn, this.profile)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "dossiers-recu-by-employee-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersValideByEmployee() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersValideByEmployee(deb, fn, this.profile)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "dossiers-valide-by-employee-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersEncoursByEmployee() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersEncoursByEmployee(deb, fn, this.profile)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "dossiers-en-cours-by-employee-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAcorrigerByEmployee() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersAcorrigerByEmployee(deb, fn, this.profile)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "dossiers-a-corriger-by-employee-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }
}
